<template>
  <div class="section py-0">
    <div class="section">
      <div class="columns">
        <div class="column">
          <h1 class="title is-1">
            {{ product(productId).name }}
          </h1>
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns is-desktop">
        <div class="column is-full is-half-desktop">
          <div class="is-flex is-justify-content-space-between">
            <h4 class="title is-3">Produkt</h4>
            <section class="b-tooltips">
              <b-tooltip
                class="mb-0"
                :label="
                  product(productId).enabled
                    ? 'Produkt ist aktiviert'
                    : 'Produkt ist deaktiviert'
                "
                position="is-top"
                style="margin-right: 20px"
              >
                <b-button style="border: 0">
                  <b-icon
                    :type="
                      product(productId).enabled ? 'is-success' : 'is-danger'
                    "
                    icon-pack="fas"
                    icon="circle"
                  ></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip
                class="mb-0"
                label="Duplicate product"
                position="is-top"
              >
                <b-button class="is-light" @click="isProductModalActive = true">
                  <b-icon icon="clone" pack="far"></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip
                class="mb-0"
                :label="
                  product(productId).enabled
                    ? 'Produkt deaktivieren'
                    : 'Produkt aktivieren'
                "
                position="is-top"
              >
                <b-button class="is-light" @click="confirmLockProduct">
                  <b-icon v-if="product(productId).enabled" icon="ban"></b-icon>
                  <b-icon v-else icon="check"></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip class="mb-0" label="Produkt löschen" position="is-top">
                <b-button class="is-light" @click="confirmDeleteProduct">
                  <b-icon icon="trash-alt"></b-icon>
                </b-button>
              </b-tooltip>
            </section>
          </div>
          <ProductSimple
            :product="product(productId)"
            @submit="updateProduct"
          />
        </div>
        <div class="column is-full is-half-desktop">
          <div class="is-flex mb-0">
            <h4
              class="title is-3 is-clickable"
              :class="activeTab === 0 ? '' : 'has-text-grey-light'"
              @click="activeTab = 0"
            >
              Übersicht
            </h4>
            <h4 class="title is-3 has-text-grey-light mx-3">|</h4>
            <h4
              class="title is-3 is-clickable"
              :class="activeTab === 1 ? '' : 'has-text-grey-light'"
              @click="activeTab = 1"
            >
              Struktur
            </h4>
          </div>
          <div class="block" v-if="activeTab === 0">
            <div class="box">
              <ProductOrgs
                :subscriberId="productOrg(productId)"
                :height="603"
                scrollable
              ></ProductOrgs>
            </div>
          </div>
          <div class="block" v-if="activeTab === 1">
            <div class="box">
              <RouteTree :productId="productIdInt" height="578px">
                <template #header-action>
                  <b-button
                    type="is-gold is-outlined"
                    size="is-small"
                    icon-left="edit"
                    tag="router-link"
                    :to="{
                      name: 'ManageProductById',
                      params: { productId },
                    }"
                    >Produkt verwalten</b-button
                  >
                </template>
              </RouteTree>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Duplicate Product Modal -->
    <b-modal :active.sync="isProductModalActive" has-modal-card>
      <template>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Duplicate product</p>
          </header>
          <section class="modal-card-body">
            <ProductSimple
              :product="product(productId)"
              @submit="duplicateProduct"
              confirmBtnLabel="Duplicate"
            />
          </section>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ProductSimple from '@/components/editProduct/ProductSimple.vue';
import ProductOrgs from '@/components/editProduct/ProductOrgs.vue';
import RouteTree from '@/components/editProduct/RouteTree.vue';

export default {
  name: 'ViewProduct',
  components: {
    ProductSimple,
    ProductOrgs,
    RouteTree,
  },
  props: ['productId'],
  sockets: {
    PRODUCT(...payload) {
      if (this.isDuplicating) {
        this.isDuplicating = false;
        this.isProductModalActive = false;

        const newProduct = payload[1];
        this.$router.push({ name: 'ViewProduct', params: { productId: newProduct.id } });
      }
    },
  },
  data() {
    return {
      activeTab: 0,
      isProductModalActive: false,
      isDuplicating: false,
    };
  },
  computed: {
    ...mapGetters({
      org: 'org/dataById',
      product: 'product/dataById',
      users: 'user/data',
      productGroup: 'product/group/dataByParentId',
      productOrg: 'product/org/dataByParentId',
    }),
    productIdInt() {
      return parseInt(this.productId, 10);
    },
  },
  methods: {
    updateProduct(payload) {
      this.$store.dispatch('product/UPDATE', payload);
    },
    deleteProduct() {
      this.$store.dispatch('product/DELETE', { id: this.productIdInt });
    },
    confirmDeleteProduct() {
      this.$buefy.dialog.confirm({
        title: 'Produkt löschen',
        // eslint-disable-next-line max-len
        message: `Sind Sie sicher, dass Sie das Produkt<b>${
          this.product(this.productId).name
        } löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: 'Produkt löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteProduct(),
      });
    },
    toggleProductLock() {
      this.$store.dispatch('product/UPDATE', {
        id: this.productIdInt,
        enabled: !this.product(this.productId).enabled,
      });
    },
    confirmLockProduct() {
      if (this.product(this.productId).enabled) {
        this.$buefy.dialog.confirm({
          title: 'Product sperren',
          message: `Sind Sie sicher, dass Sie das Product <b>${
            this.product(this.productId).name
          }</b> deaktivieren möchten?`,
          confirmText: 'Produkt deaktivieren',
          cancelText: 'Abbrechen',
          type: 'is-warning',
          hasIcon: true,
          onConfirm: () => this.toggleProductLock(),
        });
      } else {
        this.toggleProductLock();
      }
    },
    duplicateProduct(payload) {
      console.log('duplicate product', payload);
      this.isDuplicating = true;
      // omit the `enabled` prop since it's considered
      // as 'unexpected field' for the PRODUCT_DUPLICATE endpoint

      // eslint-disable-next-line no-param-reassign
      delete payload.enabled;
      this.$store.dispatch('product/DUPLICATE', payload);
    },
  },
};
</script>
